// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23666%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Conversions Page Styles - Complementing url-lists.css */

/* Make left panel stretch to full height */
.url-lists-panel {
  height: auto;
  min-height: calc(100vh - 140px);
}

/* Override form-input for conversions page - white active look */
.editor-form .form-input {
  background: #ffffff;
  border: 1.5px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.editor-form .form-input:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.editor-form .form-input:focus {
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.12);
}

/* Select styling */
.form-select {
  width: 100%;
  padding: 14px 40px 14px 18px;
  border: 1.5px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  font-size: 15px;
  font-family: inherit;
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) right 14px center no-repeat;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.form-select:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.form-select:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.12);
}

.form-select:disabled {
  background-color: rgba(0, 0, 0, 0.04);
  color: var(--text-secondary);
  cursor: not-allowed;
  opacity: 0.7;
}

/* Hint text below input */
.form-hint-inline {
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-tertiary);
}

/* Installation instruction block */
.installation-hint {
  margin-top: 12px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.installation-hint code {
  display: inline;
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
  color: var(--text-primary);
}

/* Tighter form spacing for conversions */
.editor-form {
  gap: 14px;
}

.editor-form .form-group {
  margin-bottom: 0;
}

.editor-form .form-label {
  margin-bottom: 6px;
}

.editor-form .form-input,
.editor-form .form-select {
  padding: 12px 16px;
}

.editor-form .form-select {
  padding-right: 38px;
}

/* Form Row - Side by Side Fields */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group-half {
  flex: 1 1;
}

/* Installation Guide - Clean & Simple */
.installation-guide {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.guide-header {
  margin-bottom: 16px;
}

.guide-header-content h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.guide-header-content p {
  font-size: 14px;
  color: var(--text-tertiary);
  margin: 0;
}

/* Code Block */
.single-code-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.code-panel {
  position: relative;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.code-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.code-panel-dots {
  display: none;
}

.code-panel-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.code-panel-body {
  padding: 16px;
  position: relative;
}

.code-panel-body pre {
  margin: 0;
  padding: 0;
  padding-right: 100px;
}

.code-panel-body code {
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 13px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  word-break: break-all;
}

/* Copy Button */
.btn-copy-premium {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  color: var(--text-secondary);
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-copy-premium svg {
  width: 14px;
  height: 14px;
}

.btn-copy-premium:hover {
  color: var(--accent-orange);
  border-color: var(--accent-orange);
  background: rgba(255, 107, 74, 0.04);
}

.btn-copy-premium.copied {
  color: #10b981;
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.04);
}

/* Info Cards */
.info-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-card {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.info-card-icon {
  font-size: 16px;
  line-height: 1;
}

.info-card-content {
  flex: 1 1;
}

.info-card-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.info-card-text {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
}

.info-card-text code {
  display: block;
  margin-top: 6px;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 11px;
  color: #333;
}

/* Steps */
.guide-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.guide-step {
  display: flex;
  gap: 14px;
}

.step-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-number {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-orange);
  color: white;
  font-size: 13px;
  font-weight: 600;
  border-radius: 50%;
}

.step-line {
  flex: 1 1;
  width: 2px;
  background: rgba(0, 0, 0, 0.08);
  margin-top: 8px;
  min-height: 30px;
}

.step-content {
  flex: 1 1;
  padding-top: 2px;
}

.step-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 6px;
}

.step-desc {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 12px;
}

.step-hint {
  font-size: 13px;
  color: var(--text-tertiary);
  margin: 8px 0 12px 0;
}

.step-hint code {
  background: rgba(0, 0, 0, 0.06);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
  color: var(--text-primary);
}

.step-desc code {
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

/* Code Snippet Inline */
.code-snippet-inline {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 10px 12px;
}

.code-snippet-inline code {
  flex: 1 1;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
  color: #333;
  word-break: break-all;
}

.btn-copy-sm {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  color: var(--text-tertiary);
}

.btn-copy-sm svg {
  width: 14px;
  height: 14px;
}

.btn-copy-sm:hover {
  color: var(--accent-orange);
  border-color: var(--accent-orange);
}

.btn-copy-sm.copied {
  color: #10b981;
  border-color: #10b981;
}

/* Example Box */
.example-box {
  margin-top: 10px;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.example-box-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  margin-bottom: 6px;
}

.example-box code {
  display: block;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 11px;
  color: #333;
  line-height: 1.5;
}

/* Examples Section */
.examples-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.examples-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.example-item {
  margin-bottom: 16px;
}

.example-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: 6px;
}

.example-item pre {
  margin: 0;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  overflow-x: auto;
}

.example-item code {
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 13px;
  color: var(--text-primary);
  line-height: 1.5;
}

.examples-note {
  margin-top: 20px;
  margin-bottom: 24px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.examples-note code {
  background: rgba(0, 0, 0, 0.06);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
  color: var(--text-primary);
}

/* Delete/Archive Confirmation Modal */
.message-modal {
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2);
  animation: modalSlideUp 0.3s ease;
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.message-modal-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.message-modal-icon.delete {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}

.message-modal-icon svg {
  width: 28px;
  height: 28px;
}

.message-modal h3 {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 12px 0;
}

.message-modal p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.message-modal p strong {
  color: var(--text-primary);
}

.message-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.message-modal-btn-secondary,
.message-modal-btn-danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  min-width: 100px;
}

.message-modal-btn-secondary {
  background: rgba(0, 0, 0, 0.04);
  color: var(--text-secondary);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.message-modal-btn-secondary:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.08);
  color: var(--text-primary);
}

.message-modal-btn-danger {
  background: #e74c3c;
  color: white;
  box-shadow: 0 4px 16px rgba(231, 76, 60, 0.3);
}

.message-modal-btn-danger:hover:not(:disabled) {
  background: #c0392b;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);
}

.message-modal-btn-secondary:disabled,
.message-modal-btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.message-modal-btn-danger .btn-spinner {
  width: 16px;
  height: 16px;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: white;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Conversion Stats Cards - Dashboard style */
.conversion-stats-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.conversion-stat-card {
  flex: 1 1 130px;
  min-width: 130px;
  max-width: 200px;
}

.conversion-stat-card .stat-label {
  white-space: nowrap;
}

/* Force editor panel to not overflow */
.url-editor-panel {
  overflow-x: hidden;
}

.editor-content {
  overflow-x: hidden;
}

.conversion-stat-card {
  background: var(--bg-card, #fff);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  padding: 20px 24px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.conversion-stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(135deg, #FF6B4A, #E94B6C, #8E3A9A);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.conversion-stat-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 107, 74, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.conversion-stat-card:hover::before {
  opacity: 1;
}

.conversion-stat-card .stat-value {
  font-size: 32px;
  font-weight: 600;
  font-family: 'DM Sans', sans-serif;
  color: var(--text-primary);
  line-height: 1;
  margin-bottom: 8px;
}

.conversion-stat-card .stat-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.conversion-stat-card .currency-symbol {
  font-size: 0.55em;
  font-weight: 400;
  color: var(--text-tertiary);
  margin-right: 2px;
}

/* Secondary card - Site Total (soft coral tint) */
.conversion-stat-card-secondary {
  background: linear-gradient(135deg, #FFF5F3 0%, #FFF0ED 100%);
  border: 1px solid rgba(255, 107, 74, 0.15);
}

.conversion-stat-card-secondary .stat-value {
  font-size: 28px;
  color: #1a1a1a;
}

.conversion-stat-card-secondary .stat-label {
  color: #E94B6C;
  margin-bottom: 2px;
}

.conversion-stat-card-secondary .stat-sublabel {
  font-size: 10px;
  font-weight: 400;
  color: #999;
  text-transform: none;
  letter-spacing: 0;
}

.conversion-stat-card-secondary:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 107, 74, 0.3);
  box-shadow: 0 4px 12px rgba(255, 107, 74, 0.1);
}

.conversion-stat-card-secondary::before {
  display: none;
}

/* Responsive */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .message-modal {
    padding: 24px;
  }

  .message-modal-actions {
    flex-direction: column;
  }

  .message-modal-btn-secondary,
  .message-modal-btn-danger {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .conversion-stat-card {
    flex: 1 1 100%;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/conversions.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D,2CAA2C;AAC3C;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,4BAA4B;EAC5B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,uFAA4T;EAC5T,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EAGzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,qDAAqD;EACrD,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,8DAA8D;EAC9D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":["/* Conversions Page Styles - Complementing url-lists.css */\n\n/* Make left panel stretch to full height */\n.url-lists-panel {\n  height: auto;\n  min-height: calc(100vh - 140px);\n}\n\n/* Override form-input for conversions page - white active look */\n.editor-form .form-input {\n  background: #ffffff;\n  border: 1.5px solid rgba(0, 0, 0, 0.12);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.editor-form .form-input:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.editor-form .form-input:focus {\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.12);\n}\n\n/* Select styling */\n.form-select {\n  width: 100%;\n  padding: 14px 40px 14px 18px;\n  border: 1.5px solid rgba(0, 0, 0, 0.12);\n  border-radius: 12px;\n  font-size: 15px;\n  font-family: inherit;\n  background: #ffffff url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") right 14px center no-repeat;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.form-select:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.form-select:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.12);\n}\n\n.form-select:disabled {\n  background-color: rgba(0, 0, 0, 0.04);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Hint text below input */\n.form-hint-inline {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n/* Installation instruction block */\n.installation-hint {\n  margin-top: 12px;\n  padding: 12px 14px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.installation-hint code {\n  display: inline;\n  padding: 2px 6px;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 12px;\n  color: var(--text-primary);\n}\n\n/* Tighter form spacing for conversions */\n.editor-form {\n  gap: 14px;\n}\n\n.editor-form .form-group {\n  margin-bottom: 0;\n}\n\n.editor-form .form-label {\n  margin-bottom: 6px;\n}\n\n.editor-form .form-input,\n.editor-form .form-select {\n  padding: 12px 16px;\n}\n\n.editor-form .form-select {\n  padding-right: 38px;\n}\n\n/* Form Row - Side by Side Fields */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group-half {\n  flex: 1;\n}\n\n/* Installation Guide - Clean & Simple */\n.installation-guide {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.guide-header {\n  margin-bottom: 16px;\n}\n\n.guide-header-content h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px 0;\n}\n\n.guide-header-content p {\n  font-size: 14px;\n  color: var(--text-tertiary);\n  margin: 0;\n}\n\n/* Code Block */\n.single-code-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.code-panel {\n  position: relative;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.code-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: rgba(0, 0, 0, 0.02);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.code-panel-dots {\n  display: none;\n}\n\n.code-panel-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.code-panel-body {\n  padding: 16px;\n  position: relative;\n}\n\n.code-panel-body pre {\n  margin: 0;\n  padding: 0;\n  padding-right: 100px;\n}\n\n.code-panel-body code {\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #333;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n/* Copy Button */\n.btn-copy-premium {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--text-secondary);\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.btn-copy-premium svg {\n  width: 14px;\n  height: 14px;\n}\n\n.btn-copy-premium:hover {\n  color: var(--accent-orange);\n  border-color: var(--accent-orange);\n  background: rgba(255, 107, 74, 0.04);\n}\n\n.btn-copy-premium.copied {\n  color: #10b981;\n  border-color: #10b981;\n  background: rgba(16, 185, 129, 0.04);\n}\n\n/* Info Cards */\n.info-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.info-card {\n  display: flex;\n  gap: 12px;\n  padding: 12px 14px;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n}\n\n.info-card-icon {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.info-card-content {\n  flex: 1;\n}\n\n.info-card-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.info-card-text {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.info-card-text code {\n  display: block;\n  margin-top: 6px;\n  padding: 8px 10px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 6px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 11px;\n  color: #333;\n}\n\n/* Steps */\n.guide-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.guide-step {\n  display: flex;\n  gap: 14px;\n}\n\n.step-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.step-number {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent-orange);\n  color: white;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 50%;\n}\n\n.step-line {\n  flex: 1;\n  width: 2px;\n  background: rgba(0, 0, 0, 0.08);\n  margin-top: 8px;\n  min-height: 30px;\n}\n\n.step-content {\n  flex: 1;\n  padding-top: 2px;\n}\n\n.step-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 6px;\n}\n\n.step-desc {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-bottom: 12px;\n}\n\n.step-hint {\n  font-size: 13px;\n  color: var(--text-tertiary);\n  margin: 8px 0 12px 0;\n}\n\n.step-hint code {\n  background: rgba(0, 0, 0, 0.06);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 12px;\n  color: var(--text-primary);\n}\n\n.step-desc code {\n  background: rgba(0, 0, 0, 0.05);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n/* Code Snippet Inline */\n.code-snippet-inline {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n.code-snippet-inline code {\n  flex: 1;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 12px;\n  color: #333;\n  word-break: break-all;\n}\n\n.btn-copy-sm {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  color: var(--text-tertiary);\n}\n\n.btn-copy-sm svg {\n  width: 14px;\n  height: 14px;\n}\n\n.btn-copy-sm:hover {\n  color: var(--accent-orange);\n  border-color: var(--accent-orange);\n}\n\n.btn-copy-sm.copied {\n  color: #10b981;\n  border-color: #10b981;\n}\n\n/* Example Box */\n.example-box {\n  margin-top: 10px;\n  padding: 10px 12px;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n}\n\n.example-box-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  margin-bottom: 6px;\n}\n\n.example-box code {\n  display: block;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 11px;\n  color: #333;\n  line-height: 1.5;\n}\n\n/* Examples Section */\n.examples-section {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.examples-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n}\n\n.example-item {\n  margin-bottom: 16px;\n}\n\n.example-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n}\n\n.example-item pre {\n  margin: 0;\n  padding: 12px 14px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.example-item code {\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 13px;\n  color: var(--text-primary);\n  line-height: 1.5;\n}\n\n.examples-note {\n  margin-top: 20px;\n  margin-bottom: 24px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.examples-note code {\n  background: rgba(0, 0, 0, 0.06);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', 'Consolas', monospace;\n  font-size: 12px;\n  color: var(--text-primary);\n}\n\n/* Delete/Archive Confirmation Modal */\n.message-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 32px;\n  max-width: 400px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2);\n  animation: modalSlideUp 0.3s ease;\n}\n\n@keyframes modalSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.message-modal-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n}\n\n.message-modal-icon.delete {\n  background: rgba(231, 76, 60, 0.1);\n  color: #e74c3c;\n}\n\n.message-modal-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.message-modal h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n}\n\n.message-modal p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.message-modal p strong {\n  color: var(--text-primary);\n}\n\n.message-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.message-modal-btn-secondary,\n.message-modal-btn-danger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  min-width: 100px;\n}\n\n.message-modal-btn-secondary {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--text-secondary);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.message-modal-btn-secondary:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.08);\n  color: var(--text-primary);\n}\n\n.message-modal-btn-danger {\n  background: #e74c3c;\n  color: white;\n  box-shadow: 0 4px 16px rgba(231, 76, 60, 0.3);\n}\n\n.message-modal-btn-danger:hover:not(:disabled) {\n  background: #c0392b;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);\n}\n\n.message-modal-btn-secondary:disabled,\n.message-modal-btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.message-modal-btn-danger .btn-spinner {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n  border-color: rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n}\n\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(4px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Conversion Stats Cards - Dashboard style */\n.conversion-stats-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.conversion-stat-card {\n  flex: 1 1 130px;\n  min-width: 130px;\n  max-width: 200px;\n}\n\n.conversion-stat-card .stat-label {\n  white-space: nowrap;\n}\n\n/* Force editor panel to not overflow */\n.url-editor-panel {\n  overflow-x: hidden;\n}\n\n.editor-content {\n  overflow-x: hidden;\n}\n\n.conversion-stat-card {\n  background: var(--bg-card, #fff);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 16px;\n  padding: 20px 24px;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.conversion-stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background: linear-gradient(135deg, #FF6B4A, #E94B6C, #8E3A9A);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.conversion-stat-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(255, 107, 74, 0.2);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.conversion-stat-card:hover::before {\n  opacity: 1;\n}\n\n.conversion-stat-card .stat-value {\n  font-size: 32px;\n  font-weight: 600;\n  font-family: 'DM Sans', sans-serif;\n  color: var(--text-primary);\n  line-height: 1;\n  margin-bottom: 8px;\n}\n\n.conversion-stat-card .stat-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.conversion-stat-card .currency-symbol {\n  font-size: 0.55em;\n  font-weight: 400;\n  color: var(--text-tertiary);\n  margin-right: 2px;\n}\n\n/* Secondary card - Site Total (soft coral tint) */\n.conversion-stat-card-secondary {\n  background: linear-gradient(135deg, #FFF5F3 0%, #FFF0ED 100%);\n  border: 1px solid rgba(255, 107, 74, 0.15);\n}\n\n.conversion-stat-card-secondary .stat-value {\n  font-size: 28px;\n  color: #1a1a1a;\n}\n\n.conversion-stat-card-secondary .stat-label {\n  color: #E94B6C;\n  margin-bottom: 2px;\n}\n\n.conversion-stat-card-secondary .stat-sublabel {\n  font-size: 10px;\n  font-weight: 400;\n  color: #999;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.conversion-stat-card-secondary:hover {\n  transform: translateY(-2px);\n  border-color: rgba(255, 107, 74, 0.3);\n  box-shadow: 0 4px 12px rgba(255, 107, 74, 0.1);\n}\n\n.conversion-stat-card-secondary::before {\n  display: none;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .message-modal {\n    padding: 24px;\n  }\n\n  .message-modal-actions {\n    flex-direction: column;\n  }\n\n  .message-modal-btn-secondary,\n  .message-modal-btn-danger {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .conversion-stat-card {\n    flex: 1 1 100%;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
